var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalSimple',{staticClass:"sw-FAQImagePreview",on:{"closeModal":function($event){return _vm.$emit('close')}}},[_c('img',{staticClass:"sw-FAQImagePreview_Image",attrs:{"src":_vm.imgSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }